import React, { useEffect, useState } from 'react';

const Tooltip = ({ text, position, containerWidth, containerHeight }) => {
  const [tooltipStyle, setTooltipStyle] = useState({});
  
  useEffect(() => {
    if (!position) return;

    // Create temporary element to measure text width
    const tempSpan = document.createElement('span');
    tempSpan.style.visibility = 'hidden';
    tempSpan.style.position = 'absolute';
    tempSpan.style.whiteSpace = 'nowrap';
    tempSpan.innerHTML = text;
    document.body.appendChild(tempSpan);
    
    const textWidth = tempSpan.offsetWidth;
    document.body.removeChild(tempSpan);

    // Calculate available space
    const padding = 20; // 10px padding on each side
    const tooltipWidth = Math.min(200, textWidth + padding);
    
    // Adjust position to keep tooltip inside container
    let left = position.x + 10;
    let top = position.y - 10;

    // Adjust horizontal position if tooltip would overflow
    if (left + tooltipWidth > containerWidth) {
      left = position.x - tooltipWidth - 10;
    }

    // Adjust vertical position if tooltip would overflow
    if (top + 50 > containerHeight) { // 50 is approximate max height
      top = containerHeight - 60;
    }
    
    // Keep tooltip from going off the left side
    if (left < 0) left = 10;
    
    // Keep tooltip from going off the top
    if (top < 0) top = 10;

    setTooltipStyle({
      position: 'absolute',
      left: `${left}px`,
      top: `${top}px`,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      color: 'white',
      padding: '5px 10px',
      borderRadius: '4px',
      fontSize: '14px',
      pointerEvents: 'none',
      zIndex: 1000,
      maxWidth: '200px',
      wordWrap: 'break-word',
      whiteSpace: 'normal',
      maxHeight: '100px',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    });
  }, [text, position, containerWidth, containerHeight]);

  if (!position) return null;

  return (
    <div style={tooltipStyle}>
      {text}
    </div>
  );
};

export default Tooltip;